import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '@/layout'

Vue.use(Router)

/**
 * 注意: 側邊欄中的子菜單僅在當前路由的 children 長度大於等於 1 時才會顯示
 * 詳細參考：https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   如果設為 true，該路由項目將不顯示在側邊欄中 (預設為 false)
 * alwaysShow: true               如果設為 true，將始終顯示父菜單
 *                                如果未配置 alwaysShow，當子路由數量多於一個時，父路由將顯示為嵌套模式；
 *                                如果只有一個子路由，則不顯示父菜單
 * redirect: noRedirect           如果設為 noRedirect，點擊麵包屑將不進行跳轉
 * name: 'router-name'            路由名稱，主要用於 <keep-alive> 必須配置該屬性 (強烈建議設置)
 * meta : {
 *  roles: ['admin', 'editor']    定義角色權限，只有指定角色的使用者才能訪問該路由 (可設置多個角色)
 *  title: 'title'               設置該路由顯示的名稱，會顯示在側邊欄和麵包屑中 (建議設置)
 *  icon: 'svg-name'/'el-icon-x' 設置顯示在側邊欄中的圖標，可以是 SVG 圖標或 Element UI 圖標
 *  noCache: true                如果設為 true，此頁面將不會被 <keep-alive> 緩存 (預設為 false)
 *  affix: true                  如果設為 true，該標籤會固定在標籤欄 (tags-view) 中，無法被關閉
 *  breadcrumb: false            如果設為 false，該路由項目將不顯示在麵包屑中 (預設為 true)
 *  activeMenu: '/example/list'  如果設置了此屬性，當前訪問的頁面會高亮指定的側邊欄路徑
 * }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/Redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/ErrorPage/404'),
    hidden: true
  },
  {
    path: '/sign-tasks',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/SignTasks/index'),
        name: 'signTasks',
        meta: { title: '簽署任務', icon: 'form', affix: true }
      }
    ]
  },
  {
    path: '/patients',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/Patients/index'),
        name: 'patients',
        meta: { title: '簽署者', icon: 'user', affix: false }
      }
    ]
  },
  {
    path: '/documents',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/Documents/index'),
        name: 'documents',
        meta: { title: '文件庫', icon: 'documentation', affix: false }
      }
    ]
  },
  {
    path: '/folders',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/Folders/index'),
        name: 'folders',
        meta: { title: '文件夾', icon: 'tab', affix: false }
      }
    ]
  },
  {
    path: '/change-password',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/ChangePassword/index'),
        name: 'changePassword',
        meta: { title: '變更密碼', icon: 'lock', affix: false }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/sign-tasks'
  }
]

export const asyncRoutes = [
  {
    path: '/user-management',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/UserManagement/index'),
        name: 'userManagement',
        meta: { title: '帳號管理', icon: 'tree', roles: ['owner', 'admin'] }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
